import { render, staticRenderFns } from "./ModuleSend.vue?vue&type=template&id=4889d077&scoped=true&"
import script from "./ModuleSend.vue?vue&type=script&lang=js&"
export * from "./ModuleSend.vue?vue&type=script&lang=js&"
import style0 from "./ModuleSend.vue?vue&type=style&index=0&id=4889d077&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4889d077",
  null
  
)

export default component.exports